import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f9ad5bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "industrial-model-item"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_4 = {
  class: "num-info"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "模型数量", -1));
const _hoisted_6 = {
  class: "num"
};
const _hoisted_7 = {
  class: "icon"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "同比", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Top = _resolveComponent("Top");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createTextVNode(_toDisplayString($props.info.title), 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString($props.info.num1) + "% ", 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Top)]),
    _: 1
  })]), _hoisted_8])])]);
}